import type { Constructor, LitMixinBase } from './mixin-types';
import { property } from 'lit/decorators.js';
import { consume } from '@lit/context';
import { RealtimeContext } from '../contexts/realtime-context';
import { RealtimeConnection } from '../realtime/realtime-connection';

// Consumer mixin for any page or component that needs to subscribe to
// realtime events (sales orders board, menu publish notifications, etc.).
// Use `realtime?.on('eventName', handler)` in connectedCallback and store
// the unsubscribe function for disconnectedCallback.
export const WithRealtimeConsumer = <T extends LitMixinBase>(superClass: T) => {
  class WithRealtimeConsumerClass extends superClass {
    @consume({ context: RealtimeContext, subscribe: true })
    @property({ attribute: false })
    public realtime?: RealtimeConnection;
  }

  return WithRealtimeConsumerClass as Constructor<WithRealtimeConsumerInterface> &
    T;
};

export interface WithRealtimeConsumerInterface {
  realtime?: RealtimeConnection;
}
